export const isValidTime = (time: string): boolean => {
    // Regular expression for hh:mm:ss AM/PM format
    const regex = /^(0[1-9]|1[0-2]):([0-5][0-9]):([0-5][0-9])\s([APap][Mm])$/;
    return regex.test(time);
  };